import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const BackIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M15.975 3.00036C15.7627 3.00668 15.5612 3.09542 15.4131 3.24777L7.24026 11.4204C7.08705 11.5737 7.00098 11.7815 7.00098 11.9982C7.00098 12.215 7.08705 12.4228 7.24026 12.5761L15.4131 20.7487C15.4884 20.8272 15.5786 20.8898 15.6785 20.9329C15.7783 20.9761 15.8857 20.9988 15.9944 21C16.1032 21.0011 16.211 20.9805 16.3117 20.9394C16.4124 20.8983 16.5038 20.8375 16.5807 20.7606C16.6576 20.6837 16.7184 20.5923 16.7595 20.4916C16.8006 20.3909 16.8212 20.2831 16.8201 20.1743C16.819 20.0656 16.7962 19.9582 16.753 19.8584C16.7099 19.7586 16.6473 19.6684 16.5688 19.5931L8.9738 11.9982L16.5688 4.40343C16.6869 4.28864 16.7676 4.14084 16.8003 3.97942C16.8329 3.81799 16.816 3.65046 16.7519 3.49879C16.6877 3.34712 16.5791 3.21838 16.4405 3.12943C16.3019 3.04049 16.1397 2.9955 15.975 3.00036Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(BackIcon)
